import { useSafeLayoutEffect } from '../useSafeLayoutEffect/useSafeLayoutEffect';

const useBodyClass = (classNames: string | string[]): void => {
  useSafeLayoutEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const classes = Array.isArray(classNames) ? classNames : [classNames];
    document.body.classList.add(...classes);

    return () => {
      document.body.classList.remove(...classes);
    };
  }, [classNames]);
};

export default useBodyClass;
